/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Storedropdown_Launcher1Inputs */

const id_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peluncur`)
};

const ms_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelancar`)
};

const da_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const de_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const en_us2_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const es_es2_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const es_mx2_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const fil_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const fr_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const it_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const hu_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const nl_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const no_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const pl_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const pt_br2_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const pt_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const ro_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const fi_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const sv_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const vi_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình khởi chạy`)
};

const tr_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlatıcı`)
};

const cs_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spouštěč`)
};

const bg_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стартер`)
};

const ru_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лаунчер`)
};

const uk_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лаунчер`)
};

const ar_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المشغل`)
};

const hi_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉन्चर`)
};

const th_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const ja_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ランチャー`)
};

const zh_cn2_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const zh_hant1_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

const ko_components_storedropdown_launcher1 = /** @type {(inputs: Components_Storedropdown_Launcher1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

/**
* | output |
* | --- |
* | "Launcher" |
*
* @param {Components_Storedropdown_Launcher1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_storedropdown_launcher1 = /** @type {((inputs?: Components_Storedropdown_Launcher1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Storedropdown_Launcher1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_storedropdown_launcher1(inputs)
	if (locale === "ms") return ms_components_storedropdown_launcher1(inputs)
	if (locale === "da") return da_components_storedropdown_launcher1(inputs)
	if (locale === "de") return de_components_storedropdown_launcher1(inputs)
	if (locale === "en-US") return en_us2_components_storedropdown_launcher1(inputs)
	if (locale === "es-ES") return es_es2_components_storedropdown_launcher1(inputs)
	if (locale === "es-MX") return es_mx2_components_storedropdown_launcher1(inputs)
	if (locale === "fil") return fil_components_storedropdown_launcher1(inputs)
	if (locale === "fr") return fr_components_storedropdown_launcher1(inputs)
	if (locale === "it") return it_components_storedropdown_launcher1(inputs)
	if (locale === "hu") return hu_components_storedropdown_launcher1(inputs)
	if (locale === "nl") return nl_components_storedropdown_launcher1(inputs)
	if (locale === "no") return no_components_storedropdown_launcher1(inputs)
	if (locale === "pl") return pl_components_storedropdown_launcher1(inputs)
	if (locale === "pt-BR") return pt_br2_components_storedropdown_launcher1(inputs)
	if (locale === "pt") return pt_components_storedropdown_launcher1(inputs)
	if (locale === "ro") return ro_components_storedropdown_launcher1(inputs)
	if (locale === "fi") return fi_components_storedropdown_launcher1(inputs)
	if (locale === "sv") return sv_components_storedropdown_launcher1(inputs)
	if (locale === "vi") return vi_components_storedropdown_launcher1(inputs)
	if (locale === "tr") return tr_components_storedropdown_launcher1(inputs)
	if (locale === "cs") return cs_components_storedropdown_launcher1(inputs)
	if (locale === "bg") return bg_components_storedropdown_launcher1(inputs)
	if (locale === "ru") return ru_components_storedropdown_launcher1(inputs)
	if (locale === "uk") return uk_components_storedropdown_launcher1(inputs)
	if (locale === "ar") return ar_components_storedropdown_launcher1(inputs)
	if (locale === "hi") return hi_components_storedropdown_launcher1(inputs)
	if (locale === "th") return th_components_storedropdown_launcher1(inputs)
	if (locale === "ja") return ja_components_storedropdown_launcher1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_storedropdown_launcher1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_storedropdown_launcher1(inputs)
	return ko_components_storedropdown_launcher1(inputs)
});
export { components_storedropdown_launcher1 as "components.storeDropdown.launcher" }